import { defineStore } from "pinia";
import _ from "lodash";
import * as Flagging from "@/shared/flagging";
import Vue from "vue";
import {
    FeatureFlags,
    FeatureFlagState
} from "@/shared/types";

export const initialState: FeatureFlagState = {
    featureFlagsLoadedState: false,
    featureFlagsTimedOutState: false,
    flags: Flagging.defaultFlagState,
    userTargeting: {}
};

export const getFeatureFlagCallbacks = (): Flagging.FeatureFlagCallbacks => ({
    onRetrieval: flags => {
        const featureFlagStore = useFeatureFlagStore();
        featureFlagStore.featureFlagsLoaded(flags);
    },
    onTargetingUpdate: (flags, targeting) => {
        const featureFlagStore = useFeatureFlagStore();
        featureFlagStore.featureFlagsUpdated(flags);
        featureFlagStore.targetingUpdated(targeting);
    },
    onTimeout: () => {
        const featureFlagStore = useFeatureFlagStore();
        featureFlagStore.featureFlagsTimedOut();
    }
});

export const useFeatureFlagStore = defineStore("featureFlag", {
    state: (): FeatureFlagState => (_.cloneDeep(initialState)),
    getters: {
        featureFlagsAvailable: (state): boolean => state.featureFlagsLoadedState || state.featureFlagsTimedOutState,
    },
    actions: {
        setFlagsState (flags: FeatureFlags, state: FeatureFlagState) {
            const keys = Object.keys(flags);
            keys.forEach(key => {
                Vue.set(state.flags, key, flags[key]);
            });
        },
        setFeatureFlags (newState: FeatureFlags) {
            this.setFlagsState(newState, this);
        },
        setfeatureFlagsTimedOut () {
            if (this.featureFlagsLoadedState) {
                return;
            }
            this.featureFlagsTimedOutState = true;
        },
        setfeatureFlagsLoaded (newState: FeatureFlags) {
            this.setFlagsState(newState, this);
            this.featureFlagsLoadedState = true;
            this.featureFlagsTimedOutState = false;
        },

        setTargetingUpdates (updatedTargeting: Flagging.UserTargetingUpdate) {
            this.userTargeting = { ...this.userTargeting, ...updatedTargeting };
        },
        featureFlagsLoaded (featureFlags: FeatureFlags): Promise<any> {
            this.setfeatureFlagsLoaded(featureFlags);
            return Promise.resolve();
        },

        featureFlagsUpdated (featureFlags: FeatureFlags): Promise<any> {
            this.setFeatureFlags(featureFlags);
            return Promise.resolve();
        },
        featureFlagsTimedOut (): Promise<any> {
            this.setfeatureFlagsTimedOut();
            return Promise.resolve();
        },

        targetingUpdated (targeting: Flagging.UserTargetingUpdate): Promise<any> {
            this.setTargetingUpdates(targeting);
            return Promise.resolve();
        },
    }
});